import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FieldConfig } from "../../models/field.interface";
import * as _ from 'lodash';
import { NgbDropdownConfig } from '@ng-bootstrap/ng-bootstrap';
import { NgxImageCompressService } from 'ngx-image-compress';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DeleteImageComponent } from '../../../delete-image/delete-image.component';
import { ValidationService, ValidationType } from '../../services/validation.service';
import * as moment from 'moment';
import * as Compress from 'compress.js'; 
import { ImagePreviewComponent } from '../../../image-preview/image-preview.component';
@Component({
  selector: 'app-group-question',
  template: `
<div [formGroup]="group" *ngIf="field.style.visibility">
  <div class="radio-buttons grouped-questions">
    <ul class="nav header-items" *ngIf="field.showHeader">
      <li *ngFor="let item of field.data | keys;let i = index" matTooltip="{{item.value}}">
        {{item.key}}
      </li>
    </ul>
    <div class="radio-itemes">
      <p>{{field.name}}<b *ngIf="field.validation.isRequired">*</b></p>
      <mat-radio-group class="example-radio-group" [ngClass]="{'pointer-events' : !field.style.editability}" *ngFor="let item of field.data | keys;let i = index">
        <mat-radio-button class="example-radio-button" (change)="onChange(item)" [checked]="selected() === item.key" [value]="item.key"></mat-radio-button>
      </mat-radio-group>
      <div *ngIf="field.additionalInfo && field.value" class="dropdown" [ngClass]="{'pointer-events' : !field.style.editability}">
        <button class="btn btn-outline-primary" (click)="prefilledFieldsConfig.displayGroupedInfo = !prefilledFieldsConfig.displayGroupedInfo"><img src="assets/rff-images/notes-ic.svg"></button>
      </div>
    </div>
    <span class="error-message" *ngIf="field.errorMessage !== ''">{{field.errorMessage}}</span>
    <div *ngIf="prefilledFieldsConfig.displayGroupedInfo">
      <div class="add-notes">
        <div class="input-group">
          <div class="input-group-addon add-div" [ngClass]="{'pointer-events' : !field.style.editability}">
            <img src="assets/rff-images/add-img.svg" *ngIf="!showNotes" (click)="addNote()">
            <img src="assets/rff-images/new-edit.png" *ngIf="showEdit" style="height:15px;margin:5px" (click)="editDate()">
          </div>
            <p class="nt-txt">Notes</p>
            <div class="input-group-addon media-file" [ngClass]="{'pointer-events' : !field.style.editability}">
              <input type="file" (change)="onSelectFile($event)" multiple accept=".png, .jpg, .jpeg" class="media-file">
              <img src="assets/rff-images/add-images.svg">
          </div>
              <div class="cancel-add-date" *ngIf="editText">
                <img src="assets/rff-images/note-check-ic.svg" (click)="saveData(value)">
                <img src="assets/rff-images/eraser-ic.svg" (click)="clearDate()">
          </div>
              </div>
            </div>
            <div class="show-notes-div image-picker" *ngIf="showNotes">
              <input type="text" placeholder="Enter Text here" value="{{field.value.additionalInfo.comments}}" autofocus (change)="onChangeNoteValue($event.target)" [ngClass]="{'linkdisabled' : showEdit,'pointer-events' : !field.style.editability}" class="form-control">
              <div class="check-boxes" style="padding:0 10px">
              <span class="error-message adinf-err-msg" *ngIf="showError">Uploaded Image should be less than 1 MB</span>  
                <p class="max-image" *ngIf="!minimumFiveImage">You can upload max 5 images</p>
                <p class="max-image-red" *ngIf="minimumFiveImage">You can upload max 5 images</p>
                <div class="sameline-image" *ngFor='let url of urls;let i=index'>
                  <img class="img-cross" (click)="deleteImage(i)" [ngClass]="{'pointer-events' : !field.style.editability}" src="assets/rff-images/remove-ic.svg">
                  <img class="wdth-64" (click)="openImage(url.thumb)" [src]="url.thumb"> <br />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      `,
  styles: [`.check-boxes{float:left;width:100%}.check-boxes .max-image,.check-boxes .max-image-red{margin:0 0 15px!important;width:100%}`]
})
export class GroupQuestionComponent implements OnInit {
  field: FieldConfig;
  group: FormGroup;
  minimumFiveImage = false;
  showNotes = false;
  editText: boolean;
  showEdit = false;
  urls = [];
  popupImage = this.urls;
  deleteIndex;
  prefilledFieldsConfig = {
    displayGroupedInfo: false
  };
  showError = false;
  date;
  location;
  constructor(
    config: NgbDropdownConfig,
    private imageCompress: NgxImageCompressService,
    private modalService: NgbModal,
    private _validationService: ValidationService
  ) {
    config.autoClose = false;
  }
  onChange(selectedItem) {
    let selectedOption = {};
    selectedOption[selectedItem.key] = selectedItem.value;
    let addInfoDetails = { images: [], comments: '' };
    if (this.field.additionalInfo && this.field.value && this.field.value['additionalInfo']) {
      addInfoDetails = this.field.value['additionalInfo'];
    }
    this.field.value = selectedOption;
    if (this.field.additionalInfo) {
      this.field.value['additionalInfo'] = addInfoDetails;
    }
    this.group.value[this.field.id] = this.field.value;
    const data = this.group.value;
    this._validationService.applyValidation(this.field, data, [ValidationType.isRequired, ValidationType.onChange]);
  }
  selected() {
    if (this.field.value) {
      const items = Object.keys(this.field.value);
      return items[0];
    }
  }
  addNote() {
    this.showNotes = !this.showNotes;
    this.editText = true;
  }
  onChangeNoteValue(event) {
    this.field.value.additionalInfo.comments = event.value;
  }
  onSelectFile(event, image, orientation) {
    this.minimumFiveImage = false;
    if (event.target.files && event.target.files[0]) {
      let fileName = event.target.files[0].name;
      let filesAmount = event.target.files.length;
      if (filesAmount + this.urls.length <= 5) {
        if (filesAmount <= 5) {
          for (let i = 0; i < filesAmount; i++) {
            const compress = new Compress();
            let file = event.target.files[i];
            if (file && file.size > 1000000) {
              this.showError = true;
              return;
            } else {
              this.showError = false;
            }
            let reader = new FileReader(); 
            reader.onload = (event: Event) => {
              var img: any = new Image();
              img.src = reader.result;
              img.onload = () => {
                let canvas = document.createElement('canvas');
                var contex = canvas.getContext('2d');
                canvas.width = img.width;
                canvas.height = img.height;
                contex.drawImage(img, 0, 0)
                contex.font = "calc(1.2vw + 1.2vh) sans-serif";
                contex.fillStyle = "white";
                contex.fillText(this.date, 20, (img.height - 70));
                contex.fillText(this.location, 20, img.height - 30);
                this.imageCompress.compressFile(canvas.toDataURL(), 50, 50).then((result:any) => {
                  function dataURLtoFile(result, filename) {
                    var arr = result.split(','),
                      mime = arr[0].match(/:(.*?);/)[1],
                      bstr = atob(arr[1]),
                      n = bstr.length,
                      u8arr = new Uint8Array(n);
                    while (n--) {
                      u8arr[n] = bstr.charCodeAt(n);
                    }
                    return new File([u8arr], filename, { type: mime });
                  }
                  var file = dataURLtoFile(result,fileName);
                  compress.compress([file], {
                    size: 1,
                    quality: 1,
                    maxWidth: img.width,
                    maxHeight: img.height,
                    resize: false,
                  }).then((res: any) => {
                    let resultImage = res[0].prefix + res[0].data;
                    const imageData = {
                      file: file,
                      thumb: resultImage
                    }
                    this.field.value.additionalInfo.images.push(imageData);
                    this.urls.push({ src: resultImage, file: file, thumb: resultImage });
                  })
                })
              }
            };
            reader.readAsDataURL(file);
          };
        }
      } else {
        this.minimumFiveImage = true;
      }
    }
  }
  findMe() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.showPosition(position);
      });
    } else {
      alert("Geolocation is not supported by this browser.");
    }
  }

  showPosition(position) {
    this.date = 'Date: ' + moment().format('L') + ', Time: ' + moment(new Date()).format('LT');
    this.location = 'Location: ' + position.coords.latitude.toFixed(5) + ', ' + position.coords.longitude.toFixed(5);
  }
  ngOnInit() {
    this.findMe();
    if (this.field.additionalInfo && this.field.value && this.field.value !== " ") {
      if (Object.keys(this.field.value).length > 0) {
        this.showNotes = !this.showNotes;
        this.showEdit = true;
        this.field.value.additionalInfo = {
          comments: this.field.value.additionalInfo.comments,
          images: this.field.value.additionalInfo.images
        }
        _.forEach(this.field.value.additionalInfo.images, (thumb) => {
          thumb.src = thumb.thumb;
          this.urls.push(thumb);
        });
        this.prefilledFieldsConfig.displayGroupedInfo = true;
      }
    }
  }
  deleteImage(i) {
    let modalOptions: any = {
      size: 'md',
      centered: true,
      windowClass: 'md-dialog-small',
    };
    const modalRef = this.modalService.open(DeleteImageComponent, modalOptions);
    modalRef.componentInstance.popupImage = this.popupImage;
    modalRef.componentInstance.deleteIndex = i;
    modalRef.componentInstance.fieldArray = this.field.value.additionalInfo.images;
  }
  saveData() {
    this.showEdit = true;
    this.editText = !this.editText;
  }
  editDate() {
    this.showEdit = false;
    this.editText = !this.editText;
  }
  clearDate() {
    delete (this.field.value.additionalInfo.comments);
    this.field.value.additionalInfo.comments = '';
  }
  openImage(img){
    let modalOptions: any = {
      size: 'md',
      centered: true,
      windowClass: 'md-dialog-lg light-modal',
    };
    const modalRef = this.modalService.open(ImagePreviewComponent, modalOptions);
    modalRef.componentInstance.imageSrc = img;
  }
}


// WEBPACK FOOTER //
// ./src/app/rFF/fields/group-question/group-question.component.ts